import { Record } from 'immutable';
const LegacyRecipient = Record({
  avatar: null,
  email: null,
  firstName: null,
  id: null,
  lastName: null,
  recipientType: null
}, 'LegacyRecipient');
export default LegacyRecipient;